"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var REPORT_MEANINGS_STEPS = {
  MEANING: 1,
  REASONS: 2,
  TRANSLATION_SOURCES: 3,
  EXAMPLE_SENTENCES: 4,
  SYNONYMS: 5,
  WORD_LEVEL_DETAILS: 6,
  SYNONYM_ISSUE: 7,
  SYNONYM_DETAILS: 8,
  THANK_YOU: 9
};
var MEANING_FLAG_KIND_GENERAL = 'general';
var MEANING_FLAG_HUB_FOCUS_CHOICES = {
  translations: 'Translations are incorrect',
  example_sentence: 'Example sentences are incorrect',
  example_synonym: 'Example synonyms are incorrect'
};
var MEANING_FLAG_MEANING_ISSUES = [['other', 'Something else.']];
var MEANING_FLAG_WORD_LEVEL_ISSUES = [['meanings_split_wrong', "This word's meanings should be merged or split differently."], ['missing_meaning', 'This word is missing one or more meanings.'], ['other', 'Something else.']];
var SUBSTANTIVE_MEANING_REASON_CODES = ['incorrect_translation', 'other'];
var REPORT_MEANINGS_TEXT = {
  notesPrompt: 'What would you change?',
  thankYouMessage: "Thanks for your feedback. We'll look into it and modify this word's meanings if needed.",
  genericSubmitError: 'Sorry, there was a problem submitting this report. Please try again.',
  wordLevelOtherPrompt: 'What would you change?',
  wordLevelOptionalPrompt: 'Any other details? (optional)',
  synonymContext: 'Synonyms share a close meaning, but they can differ and be used in different contexts. We invite you to discuss them in the',
  synonymReportPrompt: "If you'd like to report a mistake, you can submit a report below."
};
var REPORT_MEANINGS_STEP_QUESTIONS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, REPORT_MEANINGS_STEPS.THANK_YOU, 'Thank you'), REPORT_MEANINGS_STEPS.MEANING, 'Which meaning has a problem?'), REPORT_MEANINGS_STEPS.WORD_LEVEL_DETAILS, 'Anything else to add?'), REPORT_MEANINGS_STEPS.TRANSLATION_SOURCES, 'Which translations are incorrect?'), REPORT_MEANINGS_STEPS.EXAMPLE_SENTENCES, 'Which example sentences are incorrect?'), REPORT_MEANINGS_STEPS.SYNONYMS, 'Which synonyms are incorrect?'), REPORT_MEANINGS_STEPS.SYNONYM_ISSUE, "What's wrong with this synonym?"), REPORT_MEANINGS_STEPS.SYNONYM_DETAILS, 'Anything else to add?');
var REPORT_MEANINGS_BREADCRUMB_SUBSTEP_LABELS = _defineProperty(_defineProperty(_defineProperty({}, REPORT_MEANINGS_STEPS.TRANSLATION_SOURCES, 'Translations'), REPORT_MEANINGS_STEPS.EXAMPLE_SENTENCES, 'Example sentences'), REPORT_MEANINGS_STEPS.SYNONYMS, 'Synonyms');
var ReportMeaningsWrapper = function ReportMeaningsWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0;
  var ReportMeaningsWrapperComponent = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function ReportMeaningsWrapperComponent() {
      var _this;
      _classCallCheck(this, ReportMeaningsWrapperComponent);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, ReportMeaningsWrapperComponent, [].concat(args));
      _initializerDefineProperty(_this, "step", _descriptor, _this);
      _initializerDefineProperty(_this, "selectedMeaning", _descriptor2, _this);
      _initializerDefineProperty(_this, "wordLevelReasonCode", _descriptor3, _this);
      _initializerDefineProperty(_this, "selectedReasonCodes", _descriptor4, _this);
      _initializerDefineProperty(_this, "notes", _descriptor5, _this);
      _initializerDefineProperty(_this, "focusedTranslationSourceIds", _descriptor6, _this);
      _initializerDefineProperty(_this, "focusedSentenceIds", _descriptor7, _this);
      _initializerDefineProperty(_this, "focusedSynonymIds", _descriptor8, _this);
      _initializerDefineProperty(_this, "submitting", _descriptor9, _this);
      _initializerDefineProperty(_this, "submitError", _descriptor0, _this);
      _this.reset = function () {
        _this.step = _this.synonymAssociation ? REPORT_MEANINGS_STEPS.SYNONYM_ISSUE : REPORT_MEANINGS_STEPS.MEANING;
        _this.selectedMeaning = null;
        _this.wordLevelReasonCode = null;
        _this.selectedReasonCodes = [];
        _this.notes = '';
        _this.focusedTranslationSourceIds = [];
        _this.focusedSentenceIds = [];
        _this.focusedSynonymIds = [];
        _this.submitting = false;
        _this.submitError = null;
      };
      _this.close = function () {
        var _this$props$navigatio;
        if (_this.submitting) {
          return;
        }
        if ((0, _lodash.isFunction)(_this.props.onClose)) {
          _this.props.onClose();
          return;
        }
        if ((0, _lodash.isFunction)((_this$props$navigatio = _this.props.navigation) === null || _this$props$navigatio === void 0 ? void 0 : _this$props$navigatio.goBack)) {
          _this.props.navigation.goBack();
        }
      };
      _this.finishThankYou = function () {
        _this.close();
      };
      _this.setNotes = function (value) {
        _this.notes = value;
      };
      _this.wordLevelDetailsPromptText = function () {
        if (_this.wordLevelReasonCode === 'other') {
          return REPORT_MEANINGS_TEXT.wordLevelOtherPrompt;
        }
        return REPORT_MEANINGS_TEXT.wordLevelOptionalPrompt;
      };
      _this.selectMeaning = function (meaning) {
        var _this$selectedMeaning;
        _this.wordLevelReasonCode = null;
        if (((_this$selectedMeaning = _this.selectedMeaning) === null || _this$selectedMeaning === void 0 ? void 0 : _this$selectedMeaning.id) !== meaning.id) {
          _this.focusedTranslationSourceIds = [];
          _this.focusedSentenceIds = [];
          _this.focusedSynonymIds = [];
          _this.selectedReasonCodes = [];
          _this.notes = '';
        }
        _this.selectedMeaning = meaning;
      };
      _this.selectWordLevel = function (code) {
        _this.selectedMeaning = null;
        _this.wordLevelReasonCode = code;
        _this.focusedTranslationSourceIds = [];
        _this.focusedSentenceIds = [];
        _this.focusedSynonymIds = [];
        _this.selectedReasonCodes = [];
        _this.notes = '';
      };
      _this.toggleReason = function (code) {
        if (_this.selectedReasonCodes.includes(code)) {
          _this.selectedReasonCodes = _this.selectedReasonCodes.filter(function (c) {
            return c !== code;
          });
          return;
        }
        _this.selectedReasonCodes = [].concat(_toConsumableArray(_this.selectedReasonCodes), [code]);
      };
      _this.openTranslationPickStep = function () {
        var sources = _this.focusableTranslationSources(_this.selectedMeaning);
        _this.focusedTranslationSourceIds = [];
        _this.focusedSentenceIds = [];
        _this.focusedSynonymIds = [];
        if (sources.length === 1) {
          _this.focusedTranslationSourceIds = [sources[0].id];
          return;
        }
        _this.step = REPORT_MEANINGS_STEPS.TRANSLATION_SOURCES;
      };
      _this.openExampleSentencePickStep = function () {
        var _this$selectedMeaning2;
        var sentences = ((_this$selectedMeaning2 = _this.selectedMeaning) === null || _this$selectedMeaning2 === void 0 ? void 0 : _this$selectedMeaning2.sentences) || [];
        _this.focusedTranslationSourceIds = [];
        _this.focusedSentenceIds = [];
        _this.focusedSynonymIds = [];
        if (sentences.length === 1) {
          _this.focusedSentenceIds = [sentences[0].id];
          return;
        }
        _this.step = REPORT_MEANINGS_STEPS.EXAMPLE_SENTENCES;
      };
      _this.openSynonymPickStep = function () {
        var _this$selectedMeaning3;
        var synonyms = ((_this$selectedMeaning3 = _this.selectedMeaning) === null || _this$selectedMeaning3 === void 0 ? void 0 : _this$selectedMeaning3.synonyms) || [];
        _this.focusedTranslationSourceIds = [];
        _this.focusedSentenceIds = [];
        _this.focusedSynonymIds = [];
        if (synonyms.length === 1) {
          _this.focusedSynonymIds = [synonyms[0].id];
          return;
        }
        _this.step = REPORT_MEANINGS_STEPS.SYNONYMS;
      };
      _this.setFocusedTranslationSource = function (id) {
        if (_this.focusedTranslationSourceIds.includes(id)) {
          _this.focusedTranslationSourceIds = _this.focusedTranslationSourceIds.filter(function (x) {
            return x !== id;
          });
          return;
        }
        _this.focusedTranslationSourceIds = [].concat(_toConsumableArray(_this.focusedTranslationSourceIds), [id]);
      };
      _this.setFocusedSentence = function (id) {
        if (_this.focusedSentenceIds.includes(id)) {
          _this.focusedSentenceIds = _this.focusedSentenceIds.filter(function (x) {
            return x !== id;
          });
          return;
        }
        _this.focusedSentenceIds = [].concat(_toConsumableArray(_this.focusedSentenceIds), [id]);
      };
      _this.setFocusedSynonym = function (id) {
        if (_this.focusedSynonymIds.includes(id)) {
          _this.focusedSynonymIds = _this.focusedSynonymIds.filter(function (x) {
            return x !== id;
          });
          return;
        }
        _this.focusedSynonymIds = [].concat(_toConsumableArray(_this.focusedSynonymIds), [id]);
      };
      _this.goBack = function () {
        _this.submitError = null;
        if (_this.step === REPORT_MEANINGS_STEPS.SYNONYM_DETAILS) {
          _this.step = REPORT_MEANINGS_STEPS.SYNONYM_ISSUE;
          return;
        }
        if (_this.step === REPORT_MEANINGS_STEPS.WORD_LEVEL_DETAILS) {
          _this.step = REPORT_MEANINGS_STEPS.MEANING;
          return;
        }
        if (_this.step === REPORT_MEANINGS_STEPS.REASONS) {
          _this.step = REPORT_MEANINGS_STEPS.MEANING;
          return;
        }
        if (_this.step === REPORT_MEANINGS_STEPS.TRANSLATION_SOURCES) {
          _this.focusedTranslationSourceIds = [];
          _this.step = REPORT_MEANINGS_STEPS.REASONS;
          return;
        }
        if (_this.step === REPORT_MEANINGS_STEPS.EXAMPLE_SENTENCES) {
          _this.focusedSentenceIds = [];
          _this.step = REPORT_MEANINGS_STEPS.REASONS;
          return;
        }
        if (_this.step === REPORT_MEANINGS_STEPS.SYNONYMS) {
          _this.focusedSynonymIds = [];
          _this.step = REPORT_MEANINGS_STEPS.REASONS;
          return;
        }
        _this.close();
      };
      _this.openDirectSynonymDetails = function () {
        _this.submitError = null;
        _this.step = REPORT_MEANINGS_STEPS.SYNONYM_DETAILS;
      };
      _this.openOtherWordIssue = function () {
        _this.submitError = null;
        _this.step = REPORT_MEANINGS_STEPS.MEANING;
      };
      _this.openComments = function () {
        var _this$props$navigatio2;
        if (_state.DeckUI.layout.isNative && (0, _lodash.isFunction)((_this$props$navigatio2 = _this.props.navigation) === null || _this$props$navigatio2 === void 0 ? void 0 : _this$props$navigatio2.navigate)) {
          var _DeckUI$deck, _DeckUI$deck2, _DeckUI$currentCard;
          _this.props.navigation.navigate('CardComments', {
            navigationTimeStamp: Date.now()
          });
          _state.DeckUI.designateUiElementAsSeen('commentOnboarding');
          _state.DeckUI.createEvent('deck - view comments', {
            languageId: (_DeckUI$deck = _state.DeckUI.deck) === null || _DeckUI$deck === void 0 ? void 0 : _DeckUI$deck.languageId,
            deckId: (_DeckUI$deck2 = _state.DeckUI.deck) === null || _DeckUI$deck2 === void 0 ? void 0 : _DeckUI$deck2.id,
            cardId: (_DeckUI$currentCard = _state.DeckUI.currentCard) === null || _DeckUI$currentCard === void 0 ? void 0 : _DeckUI$currentCard.id
          });
          return;
        }
        _this.close();
        setTimeout(function () {
          return _state.DeckUI.gotoCardComments(_state.DeckUI.currentCard);
        }, 0);
      };
      _this.buildPayloadForMeaningReasons = function () {
        return {
          meaningId: _this.selectedMeaning.id,
          targetKind: MEANING_FLAG_KIND_GENERAL,
          reasonCodes: _toConsumableArray(_this.selectedReasonCodes),
          translationSourceIds: _this.focusedTranslationSourceIds.length > 0 ? _toConsumableArray(_this.focusedTranslationSourceIds) : undefined,
          sentenceIds: _this.focusedSentenceIds.length > 0 ? _toConsumableArray(_this.focusedSentenceIds) : undefined,
          synonymIds: _this.focusedSynonymIds.length > 0 ? _toConsumableArray(_this.focusedSynonymIds) : undefined,
          learnerLanguageId: _this.learnerLanguageId || undefined,
          notes: _this.notes.trim() || undefined
        };
      };
      _this.buildPayloadForWordLevel = function () {
        return {
          targetKind: MEANING_FLAG_KIND_GENERAL,
          reasonCodes: [_this.wordLevelReasonCode],
          learnerLanguageId: _this.learnerLanguageId || undefined,
          notes: _this.notes.trim() || undefined
        };
      };
      _this.postReport = function (data) {
        var _this$word;
        if (!((_this$word = _this.word) !== null && _this$word !== void 0 && _this$word.id)) {
          return;
        }
        _this.submitting = true;
        _this.submitError = null;
        _state.AppUI.meaningFlagEventStore.create({
          ids: {
            wordId: _this.word.id
          },
          data: data,
          failureCallback: function failureCallback(resp) {
            var _resp$errors;
            _this.submitting = false;
            if (resp !== null && resp !== void 0 && (_resp$errors = resp.errors) !== null && _resp$errors !== void 0 && _resp$errors.length) {
              _this.submitError = resp.errors.join('. ');
              return;
            }
            _this.submitError = REPORT_MEANINGS_TEXT.genericSubmitError;
          }
        }, function (resp) {
          var _this$props$route, _this$props$route2;
          _this.submitting = false;
          if ((resp === null || resp === void 0 ? void 0 : resp.success) === false) {
            var _resp$errors2;
            _this.submitError = (resp === null || resp === void 0 || (_resp$errors2 = resp.errors) === null || _resp$errors2 === void 0 ? void 0 : _resp$errors2.join('. ')) || REPORT_MEANINGS_TEXT.genericSubmitError;
            return;
          }
          _this.step = REPORT_MEANINGS_STEPS.THANK_YOU;
          if ((_this$props$route = _this.props.route) !== null && _this$props$route !== void 0 && (_this$props$route = _this$props$route.params) !== null && _this$props$route !== void 0 && _this$props$route.trackDeckEvent) {
            var _this$word2;
            _state.DeckUI.createEvent('vocab - report meanings submitted', {
              word_id: (_this$word2 = _this.word) === null || _this$word2 === void 0 ? void 0 : _this$word2.id
            });
          }
          var routeSuccessCallback = (_this$props$route2 = _this.props.route) === null || _this$props$route2 === void 0 || (_this$props$route2 = _this$props$route2.params) === null || _this$props$route2 === void 0 ? void 0 : _this$props$route2.onSubmitSuccess;
          if ((0, _lodash.isFunction)(routeSuccessCallback)) {
            routeSuccessCallback();
          }
          if ((0, _lodash.isFunction)(_this.props.onSubmitSuccess) && _this.props.onSubmitSuccess !== routeSuccessCallback) {
            _this.props.onSubmitSuccess();
          }
        });
      };
      _this.submitMeaningFlag = function () {
        if (!_this.canSubmitCurrentStep || _this.submitting || !_this.selectedMeaning) {
          return;
        }
        _this.postReport(_this.buildPayloadForMeaningReasons());
      };
      _this.submitWordLevel = function () {
        if (!_this.wordLevelReasonCode || _this.submitting) {
          return;
        }
        _this.postReport(_this.buildPayloadForWordLevel());
      };
      _this.submitDirectSynonymReport = function () {
        if (!_this.canSubmitCurrentStep || _this.submitting) {
          return;
        }
        _this.postReport({
          meaningId: _this.synonymAssociation.meaningId,
          targetKind: MEANING_FLAG_KIND_GENERAL,
          reasonCodes: [],
          synonymIds: [_this.synonymAssociation.synonym.id],
          learnerLanguageId: _this.learnerLanguageId || undefined,
          notes: _this.notes.trim() || undefined
        });
      };
      _this.getTranslationSourceDisplayText = function (translationSource) {
        var _translationSource$so, _translationSource$so2, _translationSource$so3, _this$word3;
        var user = _this.vocabularyUser;
        var sourceText = user && (_translationSource$so = translationSource.source) !== null && _translationSource$so !== void 0 && _translationSource$so.textForUser ? translationSource.source.textForUser(user) : (_translationSource$so2 = translationSource.source) === null || _translationSource$so2 === void 0 ? void 0 : _translationSource$so2.text;
        if (!sourceText) {
          return null;
        }
        if ((_translationSource$so3 = translationSource.source) !== null && _translationSource$so3 !== void 0 && _translationSource$so3.displayGender && (_this$word3 = _this.word) !== null && _this$word3 !== void 0 && _this$word3.genderAbbreviation) {
          return "".concat(sourceText).concat(_this.word.genderAbbreviation);
        }
        return sourceText;
      };
      _this.getSentenceSourceForUser = function (sentence) {
        var _sentence$sourceForLa, _sentence$sourceForLa2;
        var user = _this.vocabularyUser;
        var userLanguageId = (user === null || user === void 0 ? void 0 : user.languageId) || 'EN';
        var preferredLanguageId = userLanguageId === 'EN2' || userLanguageId === 'EN' && user !== null && user !== void 0 && user.useBritishEnglish ? 'EN2' : userLanguageId;
        return ((_sentence$sourceForLa = sentence.sourceForLanguage) === null || _sentence$sourceForLa === void 0 ? void 0 : _sentence$sourceForLa.call(sentence, preferredLanguageId)) || ((_sentence$sourceForLa2 = sentence.sourceForLanguage) === null || _sentence$sourceForLa2 === void 0 ? void 0 : _sentence$sourceForLa2.call(sentence, userLanguageId)) || sentence.enSource;
      };
      _this.sentenceChoiceLabel = function (sentence) {
        var source = _this.getSentenceSourceForUser(sentence);
        var hint = source !== null && source !== void 0 && source.textForUser ? source.textForUser(_this.vocabularyUser) : source === null || source === void 0 ? void 0 : source.text;
        if (!hint) {
          return sentence.targetText;
        }
        return "".concat(sentence.targetText, " - ").concat(hint);
      };
      _this.focusableTranslationSources = function (meaning) {
        if (!meaning) {
          return [];
        }
        return meaning.translationSourcesForUser(_this.vocabularyUser).filter(function (ts) {
          return Boolean(_this.getTranslationSourceDisplayText(ts));
        });
      };
      _this.meaningTranslationsJoined = function (meaning) {
        return meaning.sourceTextListForUser(_this.vocabularyUser, _this.word);
      };
      _this.meaningStepNext = function () {
        if (_this.submitting || !_this.hasFirstStepChoice) {
          return;
        }
        if (_this.wordLevelReasonCode) {
          _this.step = REPORT_MEANINGS_STEPS.WORD_LEVEL_DETAILS;
          return;
        }
        _this.step = REPORT_MEANINGS_STEPS.REASONS;
      };
      _this.synonymChoiceLabel = function (syn) {
        var _syn$wordType;
        var abbreviation = (_syn$wordType = syn.wordType) === null || _syn$wordType === void 0 ? void 0 : _syn$wordType.abbreviation;
        if (!(0, _utils.isPresent)(abbreviation)) {
          return syn.targetText;
        }
        return "".concat(syn.targetText, " (").concat(abbreviation, ")");
      };
      _this.stepQuestionForStep = function () {
        return REPORT_MEANINGS_STEP_QUESTIONS[_this.step] || "What's wrong with this meaning?";
      };
      _this.breadcrumbSubstepLabel = function () {
        return REPORT_MEANINGS_BREADCRUMB_SUBSTEP_LABELS[_this.step] || null;
      };
      _this.reportingWordLabel = function () {
        if (!_this.word) {
          return null;
        }
        return _this.word.targetTextWithDefiniteArticle || _this.word.targetText || null;
      };
      _this.wordLevelIssueLabel = function () {
        if (!_this.wordLevelReasonCode) {
          return null;
        }
        var row = MEANING_FLAG_WORD_LEVEL_ISSUES.find(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
            code = _ref2[0];
          return code === _this.wordLevelReasonCode;
        });
        return row ? row[1] : null;
      };
      _this.breadcrumbSegment = function (original) {
        if (original == null || original === '') {
          return {
            text: original,
            title: undefined
          };
        }
        var str = String(original);
        var text = (0, _utils.truncateAtWordBoundary)(str, 50);
        return {
          text: text,
          title: text !== str ? str : undefined
        };
      };
      return _this;
    }
    _inherits(ReportMeaningsWrapperComponent, _React$Component);
    return _createClass(ReportMeaningsWrapperComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.reset();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
          this.reset();
        }
      }
    }, {
      key: "word",
      get: function get() {
        var _this$props$route3;
        return this.props.word || ((_this$props$route3 = this.props.route) === null || _this$props$route3 === void 0 || (_this$props$route3 = _this$props$route3.params) === null || _this$props$route3 === void 0 ? void 0 : _this$props$route3.word);
      }
    }, {
      key: "synonymAssociation",
      get: function get() {
        var _this$props$route4;
        return this.props.synonymAssociation || ((_this$props$route4 = this.props.route) === null || _this$props$route4 === void 0 || (_this$props$route4 = _this$props$route4.params) === null || _this$props$route4 === void 0 ? void 0 : _this$props$route4.synonymAssociation);
      }
    }, {
      key: "directSynonymIssueLabel",
      get: function get() {
        var _this$word4, _this$word5, _this$synonymAssociat, _this$synonymAssociat2;
        var wordLabel = ((_this$word4 = this.word) === null || _this$word4 === void 0 ? void 0 : _this$word4.targetTextWithDefiniteArticle) || ((_this$word5 = this.word) === null || _this$word5 === void 0 ? void 0 : _this$word5.targetText);
        var synonymLabel = ((_this$synonymAssociat = this.synonymAssociation) === null || _this$synonymAssociat === void 0 || (_this$synonymAssociat = _this$synonymAssociat.synonym) === null || _this$synonymAssociat === void 0 ? void 0 : _this$synonymAssociat.targetTextWithDefiniteArticle) || ((_this$synonymAssociat2 = this.synonymAssociation) === null || _this$synonymAssociat2 === void 0 || (_this$synonymAssociat2 = _this$synonymAssociat2.synonym) === null || _this$synonymAssociat2 === void 0 ? void 0 : _this$synonymAssociat2.targetText);
        if (!wordLabel || !synonymLabel) {
          return null;
        }
        return "\u201C".concat(wordLabel, "\u201D is not a synonym of \u201C").concat(synonymLabel, "\u201D.");
      }
    }, {
      key: "otherWordIssueLabel",
      get: function get() {
        var _this$word6, _this$word7;
        var wordLabel = ((_this$word6 = this.word) === null || _this$word6 === void 0 ? void 0 : _this$word6.targetTextWithDefiniteArticle) || ((_this$word7 = this.word) === null || _this$word7 === void 0 ? void 0 : _this$word7.targetText);
        return wordLabel ? "I would like to report another issue with the word \u201C".concat(wordLabel, "\u201D.") : null;
      }
    }, {
      key: "vocabularyUser",
      get: function get() {
        return _state.AppUI.user;
      }
    }, {
      key: "learnerLanguageId",
      get: function get() {
        var _this$vocabularyUser, _this$vocabularyUser2, _this$vocabularyUser3, _this$vocabularyUser4;
        if (((_this$vocabularyUser = this.vocabularyUser) === null || _this$vocabularyUser === void 0 ? void 0 : _this$vocabularyUser.languageId) === 'EN2' || ((_this$vocabularyUser2 = this.vocabularyUser) === null || _this$vocabularyUser2 === void 0 ? void 0 : _this$vocabularyUser2.languageId) === 'EN' && (_this$vocabularyUser3 = this.vocabularyUser) !== null && _this$vocabularyUser3 !== void 0 && _this$vocabularyUser3.useBritishEnglish) {
          return 'EN2';
        }
        return (_this$vocabularyUser4 = this.vocabularyUser) === null || _this$vocabularyUser4 === void 0 ? void 0 : _this$vocabularyUser4.languageId;
      }
    }, {
      key: "meaningsSorted",
      get: function get() {
        var _this$word8,
          _this2 = this;
        if (!((_this$word8 = this.word) !== null && _this$word8 !== void 0 && _this$word8.meanings)) {
          return [];
        }
        return (0, _lodash.orderBy)(this.word.meanings, 'score', 'desc').filter(function (meaning) {
          return meaning.translationSourcesForUser(_this2.vocabularyUser).length > 0;
        });
      }
    }, {
      key: "hasFirstStepChoice",
      get: function get() {
        return Boolean(this.selectedMeaning || this.wordLevelReasonCode);
      }
    }, {
      key: "hasCurrentStepSelection",
      get: function get() {
        if (this.step === REPORT_MEANINGS_STEPS.REASONS) {
          return this.selectedReasonCodes.length > 0 || this.focusedTranslationSourceIds.length > 0 || this.focusedSentenceIds.length > 0 || this.focusedSynonymIds.length > 0;
        }
        if (this.step === REPORT_MEANINGS_STEPS.TRANSLATION_SOURCES) {
          return this.focusedTranslationSourceIds.length > 0;
        }
        if (this.step === REPORT_MEANINGS_STEPS.EXAMPLE_SENTENCES) {
          return this.focusedSentenceIds.length > 0;
        }
        if (this.step === REPORT_MEANINGS_STEPS.SYNONYMS) {
          return this.focusedSynonymIds.length > 0;
        }
        return false;
      }
    }, {
      key: "canSubmitCurrentStep",
      get: function get() {
        var _this3 = this;
        if (this.step === REPORT_MEANINGS_STEPS.SYNONYM_DETAILS) {
          var _this$synonymAssociat3, _this$synonymAssociat4;
          return Boolean(((_this$synonymAssociat3 = this.synonymAssociation) === null || _this$synonymAssociat3 === void 0 ? void 0 : _this$synonymAssociat3.meaningId) && ((_this$synonymAssociat4 = this.synonymAssociation) === null || _this$synonymAssociat4 === void 0 || (_this$synonymAssociat4 = _this$synonymAssociat4.synonym) === null || _this$synonymAssociat4 === void 0 ? void 0 : _this$synonymAssociat4.id));
        }
        if (this.step === REPORT_MEANINGS_STEPS.WORD_LEVEL_DETAILS) {
          if (!this.wordLevelReasonCode) {
            return false;
          }
          var _trimmedNotes = this.notes.trim();
          if (this.wordLevelReasonCode === 'other' && !_trimmedNotes) {
            return false;
          }
          return true;
        }
        if (!this.selectedMeaning && this.step !== REPORT_MEANINGS_STEPS.MEANING) {
          return false;
        }
        var trimmedNotes = this.notes.trim();
        if (this.selectedReasonCodes.includes('other') && !trimmedNotes) {
          return false;
        }
        if (this.step === REPORT_MEANINGS_STEPS.REASONS) {
          var qualitative = SUBSTANTIVE_MEANING_REASON_CODES.some(function (code) {
            return _this3.selectedReasonCodes.includes(code);
          });
          var hasFocusedEvidence = this.focusedTranslationSourceIds.length > 0 || this.focusedSentenceIds.length > 0 || this.focusedSynonymIds.length > 0;
          return qualitative || hasFocusedEvidence || Boolean(trimmedNotes);
        }
        if (this.step === REPORT_MEANINGS_STEPS.TRANSLATION_SOURCES) {
          return this.focusedTranslationSourceIds.length > 0 || Boolean(trimmedNotes);
        }
        if (this.step === REPORT_MEANINGS_STEPS.EXAMPLE_SENTENCES) {
          return this.focusedSentenceIds.length > 0 || Boolean(trimmedNotes);
        }
        if (this.step === REPORT_MEANINGS_STEPS.SYNONYMS) {
          return this.focusedSynonymIds.length > 0 || Boolean(trimmedNotes);
        }
        return false;
      }
    }, {
      key: "notesPromptText",
      get: function get() {
        return REPORT_MEANINGS_TEXT.notesPrompt;
      }
    }, {
      key: "thankYouMessageText",
      get: function get() {
        return REPORT_MEANINGS_TEXT.thankYouMessage;
      }
    }, {
      key: "reportWordLabel",
      get: function get() {
        if (!this.word) {
          return null;
        }
        return this.word.targetTextWithDefiniteArticle || this.word.targetText || null;
      }
    }, {
      key: "reportMeaningLabel",
      get: function get() {
        if (!this.selectedMeaning) {
          return null;
        }
        return (0, _utils.truncateAtWordBoundary)(this.meaningTranslationsJoined(this.selectedMeaning), 30);
      }
    }, {
      key: "reportingBreadcrumbWordSegment",
      get: function get() {
        var wordLabel = this.reportingWordLabel();
        return wordLabel ? this.breadcrumbSegment(wordLabel) : null;
      }
    }, {
      key: "reportingBreadcrumbMeaningSegment",
      get: function get() {
        if (!this.selectedMeaning) {
          return null;
        }
        return this.breadcrumbSegment(this.meaningTranslationsJoined(this.selectedMeaning));
      }
    }, {
      key: "reportingBreadcrumbSubstepSegment",
      get: function get() {
        var substepLabel = this.breadcrumbSubstepLabel();
        return substepLabel ? this.breadcrumbSegment(substepLabel) : null;
      }
    }, {
      key: "reportingBreadcrumbWordLevelIssueSegment",
      get: function get() {
        var issueLabel = this.wordLevelIssueLabel();
        return issueLabel ? this.breadcrumbSegment(issueLabel) : null;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          steps: REPORT_MEANINGS_STEPS,
          step: this.step,
          selectedMeaning: this.selectedMeaning,
          wordLevelReasonCode: this.wordLevelReasonCode,
          selectedReasonCodes: this.selectedReasonCodes,
          notes: this.notes,
          focusedTranslationSourceIds: this.focusedTranslationSourceIds,
          focusedSentenceIds: this.focusedSentenceIds,
          focusedSynonymIds: this.focusedSynonymIds,
          submitting: this.submitting,
          submitError: this.submitError,
          meaningFlagHubFocusChoices: MEANING_FLAG_HUB_FOCUS_CHOICES,
          meaningFlagMeaningIssues: MEANING_FLAG_MEANING_ISSUES,
          meaningFlagWordLevelIssues: MEANING_FLAG_WORD_LEVEL_ISSUES,
          notesPromptText: this.notesPromptText,
          thankYouMessageText: this.thankYouMessageText,
          synonymContextText: REPORT_MEANINGS_TEXT.synonymContext,
          synonymReportPromptText: REPORT_MEANINGS_TEXT.synonymReportPrompt,
          word: this.word,
          synonymAssociation: this.synonymAssociation,
          directSynonymIssueLabel: this.directSynonymIssueLabel,
          otherWordIssueLabel: this.otherWordIssueLabel,
          vocabularyUser: this.vocabularyUser,
          meaningsSorted: this.meaningsSorted,
          hasFirstStepChoice: this.hasFirstStepChoice,
          hasCurrentStepSelection: this.hasCurrentStepSelection,
          canSubmitCurrentStep: this.canSubmitCurrentStep,
          reportWordLabel: this.reportWordLabel,
          reportMeaningLabel: this.reportMeaningLabel,
          reportingBreadcrumbWordSegment: this.reportingBreadcrumbWordSegment,
          reportingBreadcrumbMeaningSegment: this.reportingBreadcrumbMeaningSegment,
          reportingBreadcrumbSubstepSegment: this.reportingBreadcrumbSubstepSegment,
          reportingBreadcrumbWordLevelIssueSegment: this.reportingBreadcrumbWordLevelIssueSegment,
          reset: this.reset,
          close: this.close,
          finishThankYou: this.finishThankYou,
          setNotes: this.setNotes,
          wordLevelDetailsPromptText: this.wordLevelDetailsPromptText,
          stepQuestionForStep: this.stepQuestionForStep,
          selectMeaning: this.selectMeaning,
          selectWordLevel: this.selectWordLevel,
          toggleReason: this.toggleReason,
          openTranslationPickStep: this.openTranslationPickStep,
          openExampleSentencePickStep: this.openExampleSentencePickStep,
          openSynonymPickStep: this.openSynonymPickStep,
          setFocusedTranslationSource: this.setFocusedTranslationSource,
          setFocusedSentence: this.setFocusedSentence,
          setFocusedSynonym: this.setFocusedSynonym,
          goBack: this.goBack,
          openDirectSynonymDetails: this.openDirectSynonymDetails,
          openOtherWordIssue: this.openOtherWordIssue,
          openComments: this.openComments,
          submitMeaningFlag: this.submitMeaningFlag,
          submitWordLevel: this.submitWordLevel,
          submitDirectSynonymReport: this.submitDirectSynonymReport,
          getTranslationSourceDisplayText: this.getTranslationSourceDisplayText,
          getSentenceSourceForUser: this.getSentenceSourceForUser,
          sentenceChoiceLabel: this.sentenceChoiceLabel,
          focusableTranslationSources: this.focusableTranslationSources,
          meaningTranslationsJoined: this.meaningTranslationsJoined,
          meaningStepNext: this.meaningStepNext,
          synonymChoiceLabel: this.synonymChoiceLabel
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "step", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return REPORT_MEANINGS_STEPS.MEANING;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "selectedMeaning", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "wordLevelReasonCode", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "selectedReasonCodes", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "notes", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "focusedTranslationSourceIds", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "focusedSentenceIds", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "focusedSynonymIds", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "submitting", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "submitError", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "word", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "word"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "synonymAssociation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "synonymAssociation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "directSynonymIssueLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "directSynonymIssueLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "otherWordIssueLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "otherWordIssueLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabularyUser", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabularyUser"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "learnerLanguageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "learnerLanguageId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "meaningsSorted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "meaningsSorted"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasFirstStepChoice", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasFirstStepChoice"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasCurrentStepSelection", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasCurrentStepSelection"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canSubmitCurrentStep", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "canSubmitCurrentStep"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "notesPromptText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "notesPromptText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "thankYouMessageText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "thankYouMessageText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reportWordLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reportWordLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reportMeaningLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reportMeaningLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reportingBreadcrumbWordSegment", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reportingBreadcrumbWordSegment"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reportingBreadcrumbMeaningSegment", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reportingBreadcrumbMeaningSegment"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reportingBreadcrumbSubstepSegment", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reportingBreadcrumbSubstepSegment"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reportingBreadcrumbWordLevelIssueSegment", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reportingBreadcrumbWordLevelIssueSegment"), _class2.prototype), _class2)) || _class;
  ReportMeaningsWrapperComponent.displayName = 'ReportMeaningsWrapperComponent';
  return ReportMeaningsWrapperComponent;
};
ReportMeaningsWrapper.displayName = 'ReportMeaningsWrapper';
var _default = exports["default"] = ReportMeaningsWrapper;